<template>
    <div class="message-preview">

        <b-card no-body>
            <b-card-header>
                <h5>{{ $i18n.gt('HEADING_MESSAGE_PREVIEW') }}</h5>
            </b-card-header>
            <b-card-body>
                <div style="white-space: pre-line">{{ fullBody }}</div>
                <hr/>
                <p v-html="$i18n.gt('PATIENT_MESSAGE_FOOTER')"></p>
            </b-card-body>
        </b-card>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
/**
 * Displays a preview of a message being edited by a practitioner
 * NB: white-space formatting in template is designed to match that used in app/mail/participant_message.php,
 * which in turn is designed to behave predictably in various email clients.
 */
import Vue from 'vue'
import Messages from '@/providers/Messages'

export default Vue.extend({
    name: 'MessagePreview',
    props: {
        toName: String,
        subject: String,
        body: String,
    },
    computed: {
        salutation() {
            return Messages.buildSalutation(this.toName)
        },
        fullBody() {
            if (this.body) {
                return this.salutation + '\n\n' + this.body
            } else {
                return ''
            }
        }
    }
})
</script>
